import PropTypes from 'prop-types';
import React from 'react';

import { cls } from '@mssgme/helpers';

import { DynamicFormInput } from './DynamicFormInput';

import styles from './DynamicFormInputs.scss';

export const DynamicFormInputs = ({ block, theme, defaultMaxSize, ...rest }) => {
    return (
        <ul {...cls([styles.root, styles[theme.gridMode]], rest)}>
            {block.items.map((item, index) => (
                <DynamicFormInput
                    as="li"
                    key={item._id || index}
                    index={index}
                    input={item}
                    defaultMaxSize={defaultMaxSize}
                    theme={theme}
                />
            ))}
        </ul>
    );
};

DynamicFormInputs.propTypes = {
    block: PropTypes.shape({
        items: PropTypes.arrayOf(
            PropTypes.shape({
                _id: PropTypes.string,
                label: PropTypes.string,
                required: PropTypes.bool,
                size: PropTypes.number,
                options: PropTypes.string,
                type: PropTypes.string,
            })
        ).isRequired,
    }).isRequired,
    theme: PropTypes.object.isRequired,
    defaultMaxSize: PropTypes.number.isRequired,
};
